<app-kpi-widget
  [title]="title"
  [icon]="'ph-duotone ph-currency-circle-dollar'"
  [isLoading]="isLoading"
  [totalValue]="value"
  [totalCost]="totalCost"
  [percentageDifference]="percentageDifference"
  [costDifference]="difference"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [valueFormatter]="formatValue.bind(this)"
  [costFormatter]="formatCost.bind(this)"
  [costDifferenceFormatter]="formatCostDifference.bind(this)"
  [isImageIcon]="false"
  [dropdownEnabled]="false"
  [hasFooter]="false"
  [hasValueOnly]="true"
  [hasDifference]="true"
  [hasCost]="true"
  [hasCostDifference]="true"
  [isUptrendPositive]="false"></app-kpi-widget>